import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { RoutingPath } from 'mbs-ui-shared';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class LicensesGuard implements CanActivate {
  private auth = inject(AuthFacade);
  private router = inject(Router);

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.auth.currentUser$.pipe(
      switchMap((user) => {
        const isPostPayment = user.ProviderInfo?.IsPostPayment;

        const url = state.url.split('?')[0];

        if (url === RoutingPath.ApLicensesAspx && isPostPayment) {
          void this.router.navigate([RoutingPath.ApLicenses]);
        }

        return of(true);
      })
    );
  }
}
